import { useState } from 'react'
import { SparklesIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/shared/components/ui/popover'
import {
	SidebarMenuButton,
	SidebarMenuItem,
} from '@/shared/components/ui/sidebar'

import { AssistantProvider } from '../providers'
import Chat from './Chat'

export function AssistantChatLauncher() {
	const { t } = useTranslation()

	const [open, setOpen] = useState(false)

	return (
		<Popover open={open} onOpenChange={(open) => open && setOpen(open)}>
			<PopoverTrigger asChild>
				<SidebarMenuItem>
					<SidebarMenuButton
						onClick={() => setOpen(true)}
						data-testid='ai-assistant-menu-item'
						tooltip={t('app.assistant', { defaultValue: 'AI Assistant' })}
					>
						<SparklesIcon className='text-primary' />
						<span>{t('app.assistant', { defaultValue: 'AI Assistant' })}</span>
					</SidebarMenuButton>
				</SidebarMenuItem>
			</PopoverTrigger>
			<AssistantProvider>
				<PopoverContent
					className='mt-10 h-[90vh] w-auto overflow-hidden rounded-2xl p-0 shadow'
					side='right'
					align='end'
				>
					<Chat close={() => setOpen(false)} />
				</PopoverContent>
			</AssistantProvider>
		</Popover>
	)
}
